import { useEffect, useState } from "react";
import apiClient from "utils/apiClient";
import { ENDPOINTS } from "utils/endpoints";

/**
 * Headline catalog counts, e.g. "142 recipes · 9 cuisines · 45 vegetarian".
 *
 * Every figure comes from a live COUNT on the backend — nothing here is a
 * constant, so the line moves the day an ingestion batch lands. A hardcoded
 * "over 100 recipes" is the failure this exists to avoid: it is wrong the
 * moment it's written and never gets corrected.
 *
 * The vegetarian figure is strictly diet == "vegetarian". Vegan dishes are not
 * folded in, so the number can be reproduced by tapping the vegetarian filter
 * next to it. Backend keeps the same rule — see catalog_stats().
 */
export function formatCatalogCounts(stats) {
  if (!stats || !stats.total_recipes) return null;

  const parts = [`${stats.total_recipes} recipe${stats.total_recipes === 1 ? "" : "s"}`];
  if (stats.cuisine_count) {
    parts.push(`${stats.cuisine_count} cuisine${stats.cuisine_count === 1 ? "" : "s"}`);
  }
  const vegetarian = stats.by_diet?.vegetarian || 0;
  if (vegetarian) parts.push(`${vegetarian} vegetarian`);

  return parts.join(" · ");
}

export function useCatalogStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get(ENDPOINTS.schedule.catalogStats)
      .then((res) => {
        if (!cancelled) setStats(res.data);
      })
      // Counts are decoration on top of the real page. A failed fetch renders
      // nothing rather than an error or a made-up number.
      .catch((err) => console.error("Failed to load catalog stats:", err.message));
    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
}
